module.exports = __webpack_public_path__ + "static/media/img4.2b4b76d3.jpg";